// extracted by mini-css-extract-plugin
export default {"content":"Footer_content__Oeyzl","list":"Footer_list__tET6V"};